<template>
  <div class="container-body">
    <div class="outer-div outer-div-min">
      <div class="inner-div">
        <div class="row text-center">
          <div class="grid-4">
            <dropdown
            :id='fileUploadId1'
            :list='periods'
            v-model='selectedPeriod'
            :defaultText='defaultText'
            :selectedItem='(gettersAggInputDataName.period) ? gettersAggInputDataName.period.name : ""' />
          </div>
          <div class="">
            <upload
            :disabled='!selectedPeriod'
            :clearUploadButtonText='clearUploadButtonText'
            :period='selectedPeriod'
            :uploadFile='uploadFile'>
            </upload>
          </div>
        </div>
      </div>
    </div>
    <error v-if='uploadResult.mistake.length > 0' :mistakes='uploadResult.mistake'></error>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import xlsx from 'xlsx'
  import Dropdown from 'src/components/shared/Dropdown'
  import * as NameSpace from '../../store/NameSpace'
  import Upload from '../../components/file-upload/Upload'
  import Error from '../../components/file-upload/Error'

  export default {
    data () {
      return {
        fileUploadId1: 'fileUploadId1',
        selectedPeriod: null,
        defaultText: 'Select Period',
        clearUploadButtonText: null,
        // clearErrors: false,
        filterArray: ['error', 'warnings', 'UPC'],
        cancelUpload: true
      }
    },
    components: {
      Dropdown,
      Upload,
      Error
    },
    methods: {
      ...mapActions({
        actionUploadFile: NameSpace.ACTION_UPLOAD_FILE,
        pop: NameSpace.SET_MODAL_CONFIG_ACTION,
        actionMistakesInUpload: NameSpace.ACTION_MISTAKES_IN_UPLOAD_FILE,
        loader: NameSpace.LOADER_SHOW_ACTION
      }),
      uploadFile (file) {
        let extension = file.name.split('.').pop()
        if (extension === 'xlsx' || extension === 'xls') {
          this.showPopUpMessage(file)
        } else {
          this.pop({
            header: 'File Not Supported.',
            message: 'Only allow xlsx or xls file',
            type: 'ERROR'
          })
        }
      },
      showPopUpMessage (file) {
        this.pop({
          header: 'INFORMATION',
          message: 'Existing data of selected period will be modified by your upload. Are you sure?',
          buttons: {
            accept: {
              text: 'YES',
              action: this.validateExcelFile.bind(this, file)
            },
            decline: {
              text: 'NO',
              present: true
            }
          }
        })
      },
      validateExcelFile (file) {
        // let duplicateUpc = []
        this.cancelUpload = true
        this.loader(true)
        const self = this
        setTimeout(() => {
          let reader = new FileReader()
          let submitOfferErrorArray = []
          reader.onload = (e) => {
            let data = (e) ? e.target.result : reader.content
            let offer = xlsx.read(data, {type: 'binary'})
            let result = {}
            let hasUpc = false
            let key = '12 DIGIT UNIT UPC (NO DASHES)'
            try {
              offer.SheetNames.forEach(function (sheetName) {
                var range = xlsx.utils.decode_range(offer.Sheets[sheetName]['!ref'])
                let C = range.s.r
                let R = range.s.r
                /* start in the first row */
                /* walk every column in the range */
                for (C = range.s.c; C <= range.e.c; ++C) {
                  var cell = offer.Sheets[sheetName][xlsx.utils.encode_cell({c: C, r: R})]
                  if (cell && cell['v'] === key) {
                    hasUpc = true
                    break
                  }
                }
                let roa = xlsx.utils.sheet_to_row_object_array(offer.Sheets[sheetName])
                // console.log(roa)
                result[sheetName] = roa
              })
            } catch (e) {
              this.hasUpc = false
            }
          // console.log(hasUpc)
            if (hasUpc) {
              self.validateXlsxContents(result, key, submitOfferErrorArray)
            } else {
              this.pop({
                header: 'Error',
                message: 'The file uploaded doesn\'t match expected format',
                type: 'ERROR'
              })
            }
            self.loader(false)
            if (submitOfferErrorArray.length > 0) {
              self.actionMistakesInUpload({mistake: submitOfferErrorArray, error: true})
            } else if (!self.cancelUpload) {
              self.actionUploadFile({
                period: this.selectedPeriod.id,
                file: file,
                type: 'OfferFile',
                name: 'offerFile.xlsx',
                filterArray: this.filterArray
              })
            // submit button should get half flag true
              self.isFileUploaded = true
            }
            self.clearUploadButtonText = true
            file = null
          }
          reader.readAsBinaryString(file)
        }, 100)
      },
      validateXlsxContents (result, key, submitOfferErrorArray) {
        let arraContent = result.Sheet1
        let alreadyError = false
        if (arraContent.length === 0) {
          this.pop({
            header: 'Error',
            message: `The file you are trying to upload doesn't have any data`,
            type: 'ERROR'
          })
          this.cancelUpload = true
          alreadyError = true
        } else {
          arraContent.forEach((upc, i) => {
            if (upc.hasOwnProperty(key)) {
              if (!upc[key]) {
                this.cancelUpload = true
                alreadyError = true
                submitOfferErrorArray.push({
                  mistakes: {
                    error: [`UPC cannot be blank in row ${i + 2}`]
                  }
                })
              }
            } else {
              this.cancelUpload = true
              alreadyError = true
              submitOfferErrorArray.push({
                mistakes: {
                  error: [`UPC cannot be blank in row ${i + 2}`]
                }
              })
            }
          })
        }
        if (!alreadyError) {
          let duplicateUpc = []
          let arrayOfUpc = arraContent.map(e => {
            return e[key]
          })
          for (let i = 0; i < arrayOfUpc.length; i++) {
            if (i !== arrayOfUpc.lastIndexOf(arrayOfUpc[i])) {
              duplicateUpc.push(arrayOfUpc[i])
              break
            }
          }
          if (duplicateUpc.length) {
            this.pop({
              header: 'Error',
              message: `The file has duplicate UPC: ${duplicateUpc}`,
              type: 'ERROR'
            })
            this.cancelUpload = true
          } else {
            this.cancelUpload = false
          }
        }
      }
    },
    watch: {
      uploadResult () {
        // console.log(this.uploadResult)
        if (this.uploadResult.success) {
          this.pop({
            header: 'File Upload',
            message: this.uploadResult.success,
            type: 'SUCCESS'
          })
        }
      },
      clearUploadButtonText () {
        let self = this
        setTimeout(() => {
          self.clearUploadButtonText = null
        }, 0)
      }
    },
    computed: {
      ...mapGetters({
        gettersLandingInfo: NameSpace.GET_LANDING_DATA,
        gettersAggInputDataName: NameSpace.GET_AGG_INPUT_FILTER_NAME,
        uploadResult: NameSpace.GETTER_UPLOAD_FILE_RESPONSE
      }),
      periods () {
        let data = this.gettersLandingInfo.data
        if (data && data.periods) {
          return data.periods.map(e => {
            let obj = {}
            obj.id = e
            obj.name = e
            return obj
          })
        } else {
          return []
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FileUpload.vue?0924ea93